import items from "../utils/types";
//console.log("src/reducers/calc.js");
// initial store
const initialStore = {
  types: formatData(items),
  sortedTypes: [],
  loading: false,
  width: null,
  size: "",
  lapp: "",
  laph: "",
  overlap: "",
};

function formatData(items) {
  let tempItems = items.map((item) => {
    let id = item.sys.id;
    let type = { ...item.fields, id };
    return type;
  });
  return tempItems;
}

// REDUCER
export default function calcReducer(state = initialStore, action) {
  const {
    etype,
    echecked,
    evalue,
    ename,
    ewidth,
    esize,
    elapp,
    elaph,
    tv4,
    overlap,
  } = action;
  let value = etype === "checkbox" ? echecked : evalue;
  if (value === tv4) {
    value = "all";
  }
  let uwidth = ewidth;
  let usize = esize;
  let ulapp = elapp;
  let ulaph = elaph;
  if (ename === "size") {
    usize = value;
    ulapp = "";
    ulaph = "";
  }
  if (ename === "lapp") {
    ulapp = value;
  }
  if (ename === "laph") {
    ulaph = value;
  }

  let tempTypes = [...state.types];

  let tTypes = [];
  // STRIP SIZE
  if (usize !== "all") {
    tTypes = tempTypes.filter((temp) => temp.size === usize);
    tempTypes = tTypes;
  }
  // LAPP
  if (ulapp !== "all") {
    tTypes = tempTypes.filter((temp) => temp.lapp === ulapp);
    if (tTypes.length === 0) {
      ulapp = "all";
      tTypes = tempTypes;
    }
    tempTypes = tTypes;
  }
  // LAPH
  if (ulaph !== "all") {
    tTypes = tempTypes.filter((temp) => temp.laph === ulaph);
    if (tTypes.length === 0) {
      ulaph = "all";
      tTypes = tempTypes;
    }
    tempTypes = tTypes;
  }

  switch (action.type) {
    // H A N D L E _ C H A N G E
    case "HANDLE_CHANGE":
      return {
        ...state,
        width: uwidth,
        size: usize,
        lapp: ulapp,
        laph: ulaph,
        [ename]: value,
        sortedTypes: tempTypes,
        overlap: overlap,
      };
    default:
      return { ...state };
  }
}
